var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1ylff0u5qa)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5.5c.483 0 .875.392.875.875v3.208a.875.875 0 0 1-1.75 0V1.375c0-.483.392-.875.875-.875zM3.075 3.575a.875.875 0 0 1 1.238 0l2.269 2.27a.875.875 0 0 1-1.238 1.237l-2.269-2.27a.875.875 0 0 1 0-1.237zm14.85 0a.875.875 0 0 1 0 1.238l-2.27 2.269a.875.875 0 1 1-1.237-1.238l2.27-2.269a.875.875 0 0 1 1.237 0zM0 11c0-.483.392-.875.875-.875h3.208a.875.875 0 0 1 0 1.75H.875A.875.875 0 0 1 0 11zm16.042 0c0-.483.391-.875.875-.875h3.208a.875.875 0 0 1 0 1.75h-3.208a.875.875 0 0 1-.875-.875zm-9.46 3.92a.875.875 0 0 1 0 1.237l-2.27 2.268a.875.875 0 0 1-1.237-1.238l2.27-2.268a.875.875 0 0 1 1.237 0zm7.836 0a.875.875 0 0 1 1.238-.001l2.268 2.268a.875.875 0 1 1-1.237 1.238l-2.269-2.268a.875.875 0 0 1 0-1.238zM10.5 16.541c.483 0 .875.391.875.875v3.208a.875.875 0 0 1-1.75 0v-3.208c0-.484.392-.875.875-.875z",
    fill: "#8A8DAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1ylff0u5qa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h21v21H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingCircle);
export default __webpack_public_path__ + "static/media/loading-circle.1233446e98d83fb56317eafae11ac208.svg";
export { ForwardRef as ReactComponent };